module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-cell",
    on: {
      "click": _vm.onFieldClick
    }
  }, [(!_vm.editMode && !_vm.showInput) ? _c('el-tooltip', {
    attrs: {
      "placement": _vm.toolTipPlacement,
      "open-delay": _vm.toolTipDelay,
      "content": _vm.toolTipContent
    }
  }, [_c('div', {
    staticClass: "cell-content",
    class: {
      'edit-enabled-cell': _vm.canEdit
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onFieldClick($event)
      }
    }
  }, [_vm._t("content")], 2)]) : _vm._e(), _vm._v(" "), (_vm.editMode || _vm.showInput) ? _c(_vm.editableComponent, _vm._g(_vm._b({
    ref: "input",
    tag: "component",
    on: {
      "focus": _vm.onFieldClick
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onInputExit($event)
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, 'component', _vm.$attrs, false), _vm.listeners), [_vm._t("edit-component-slot")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ae1c34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/EditeableCell.vue
// module id = 943
// module chunks = 170